// Shared helper for calling backend endpoints guarded by @require_auth.
// The backend cryptographically verifies the Cognito **idToken** (not the
// accessToken — its audience/token_use claims fail the id-token check).
import { getIdToken } from './authSession';

// getIdToken moved to authSession (Amplify v6). Re-export so existing importers keep working.
export { getIdToken };

/** Headers object carrying the idToken (plus any extra headers). */
export async function authHeaders(extra = {}) {
  const token = await getIdToken();
  return { ...(token ? { Authorization: `Bearer ${token}` } : {}), ...extra };
}
